import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function archiveThreadMessageSuccess(draft: Draft<IInterventionData>) {
  draft.archiveThreadMessage.config.isLoading = false;
}

export default archiveThreadMessageSuccess;
